import { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { blogPosts } from '../../data/blogPosts';

export default function BlogCarousel() {
  const { i18n } = useTranslation();
  const lng = i18n.language?.startsWith('sr') ? 'sr' : 'en';
  const picks = useMemo(() => [...blogPosts].slice(0, 4), []);
  return (
    <section style={{ padding: '40px 0' }}>
      <div className="blog-grid">
        {picks.map((p, idx) => (
          <article key={p.id} className={`blog-card blog-card-${idx+1}`} style={{ border:'1px solid #e5e7eb', borderRadius: 12, overflow:'hidden' }}>
            <img src={process.env.PUBLIC_URL + p.image} alt={lng==='sr' ? p.title_sr : p.title_en} style={{ width:'100%', height:'clamp(150px, 40vw, 220px)', objectFit:'cover' }} />
            <div style={{ padding: 16 }}>
              <h3 style={{ margin:'0 0 6px' }}>{lng==='sr' ? p.title_sr : p.title_en}</h3>
              <Link to={`/${lng}/blog/${p.slug}`}>{lng==='sr' ? 'Pročitaj više' : 'Read more'}</Link>
            </div>
          </article>
        ))}
      </div>
      <style>{`
        .blog-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 16px; }
        @media (max-width: 1100px){ .blog-grid{ grid-template-columns: repeat(3, 1fr); } }
        @media (max-width: 800px){ .blog-grid{ grid-template-columns: repeat(2, 1fr); } }
        @media (max-width: 520px){ .blog-grid{ grid-template-columns: repeat(2, 1fr); } }
      `}</style>
    </section>
  );
}
